import { useEffect, useState } from "react";
import { Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { FaSave } from "react-icons/fa";
import { useAlertMessageContext } from "../../../contexts/alert-message.context";
import { useConfirmMessageContext } from "../../../contexts/confirm-message.context";
import cndService from "../../../services/cnd.service";
import { dateToString, notNullToDate } from "../../../utilities/auxiliary-functions";
import { removeFormatDate } from "../../../utilities/masks";
import { isEmpty } from "../../../utilities/validators";
import LostAndFoundRecord from "../../records/lost-and-found.record";
import { Button } from '@mui/material'
import { AlertMessageEnum } from "../../../utilities/types";
import { useTranslateContext } from "../../../contexts/translate.context";
import { usePartnerContext } from "../../../contexts/partner.context";
import { TFilter } from "../../../types/FilterType";
import authService from "../../../services/auth.service";

export interface ILostAndFoundCondominiumFormProps {
    title: string,
    identifier: string,
    setRecord: any,
    viewOnly?: boolean
}

export const LostAndFoundCondominiumForm: React.FC<ILostAndFoundCondominiumFormProps> = (props: ILostAndFoundCondominiumFormProps) => {

    const alertContext = useAlertMessageContext();
    const confirmContext = useConfirmMessageContext();
    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const [ invalidatedForm, setInvalidatedForm ] = useState(false);
    const [ isEditForm, setEditForm ] = useState(true);

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ originRecord, setOriginRecord ] = useState({} as any);
    const [ sending, setSending ] = useState(false);

    /* TRATAMENTO PARTICULAR DO OBJETO QUE ESTA SENDO MANTIDO */
    // LostAndFound
    const [ lostAndFoundId, setLostAndFoundId ] = useState(0);
    const [ estateId, setEstateId ] = useState(0);
    const [ name, setName ] = useState('');
    const [ description, setDescription ] = useState('');
    const [ launch, setLaunch ] = useState(dateToString(new Date(), 'dd/mm/yyyy'));
    const [ delivered, setDelivered ] = useState('');
    const [ created, setCreated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));
    const [ updated, setUpdated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));

    const [ listEstate, setListEstate ] = useState([] as any);

    function fillRecord(lostAndFound: any) {

        if (!isEmpty(lostAndFound)) {
            setLostAndFoundId(lostAndFound.id);
            setEstateId(lostAndFound.estateId);
            setName(lostAndFound.name);
            setDescription(lostAndFound.description);
            setLaunch(notNullToDate(lostAndFound.launch, 'dd/mm/yyyy'));
            setDelivered(notNullToDate(lostAndFound.delivered, 'dd/mm/yyyy HH:MM:ss'));
            setCreated(notNullToDate(lostAndFound.created, 'dd/mm/yyyy HH:MM:ss'));  
            setUpdated(notNullToDate(lostAndFound.updated, 'dd/mm/yyyy HH:MM:ss'));  
        }
    } // fillRecord

    async function isValidForm() {
        let result = true;
        let emptyRequired = false;

        if (isEmpty(name))
            emptyRequired = true;
        /*
        if (isEmpty(registrationPf))
            emptyRequired = true;
        if ((!isEmpty(registrationPf)) && (!isCpf(registrationPf))) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.registration_pf);
            result = false;
        }
        */

        if (emptyRequired) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.required);
            result = false;
        }

        setInvalidatedForm(!result);
        return result;
    } // isValidForm

    function onClick_CancelLostAndFound(event: any) {
        event.preventDefault();
        props.setRecord(event, 0);
    } // onClick_CancelLostAndFound

    function fillRegister() {

        const dataRegister = {
            id : lostAndFoundId,
            estateId, 
            partnerId: partner.id,
            name, 
            description, 
            launch : removeFormatDate(launch),  
            delivered : removeFormatDate(delivered), 
            created : removeFormatDate(created), 
            updated : removeFormatDate(updated)
        };

        return dataRegister;
    } // fillRegister

    async function onClick_SaveLostAndFound(event: any) {
        event.preventDefault();
        
        const isValid = await isValidForm();
        if (isValid) {
            try {
                const isConfirmed = await confirmContext.show(props.title, display.message.confirm_record);
                if (isConfirmed) {
                    setSending(true);

                    const lostAndFound = fillRegister();
                    if (lostAndFound.id > 0)
                        await cndService.saveLostAndFound(lostAndFound.id, lostAndFound);
                    else
                        await cndService.createLostAndFound(lostAndFound);

                    setSending(false);
                    await alertContext.show(AlertMessageEnum.SUCCESS, props.title, display.message.the_record_has_been_saved_successfully);
                    props.setRecord(event, 0);
                }
            } catch (error: any) {
                setSending(false);
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
            }
        }
    } // onClick_SaveLostAndFound
    
    async function changeEstate() {
        const filter = {
            attributes: ['id','name'],
            where: { association: 1 }
        } as TFilter;
        const result = await cndService.estateSearch(filter);
        setListEstate(result.rows);
    }

    async function searchParam() {
        try {
            setEditForm(!props.viewOnly);
            if (!Number.isNaN(Number.parseInt(props.identifier ||''))) {

                const lostAndFound = await cndService.lostAndFoundById(Number(props.identifier));
                setOriginRecord(lostAndFound);
                fillRecord(lostAndFound);
            }
        } catch(error: any) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
        }
    } // searchParam

    useEffect(() => {
        if (!isLoading && !reloadPage) {
            if (isEmpty(partner))
                // eslint-disable-next-line react-hooks/exhaustive-deps
                partner = authService.currentPartner();

            changeEstate();
            searchParam();
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []); // useEffect

    function viewCadastreForm() {

        return (
            <Container fluid className="page-body lostandfound">
                <Row>
                    <Col sm={12} className="page-sweet">
                        <Card>
                            <Card.Header>
                                {(originRecord.created || originRecord.updated) && (
                                    <div className="form-identy-registry float-right">
                                        <span className="white-space"><b>Criação: </b> {dateToString(originRecord.created, 'dd/mm/yyyy HH:MM:ss')}</span>
                                        <span className="white-space"><b>Atualização: </b> {dateToString(originRecord.updated, 'dd/mm/yyyy HH:MM:ss')}</span>
                                    </div>
                                )}
                                <Card.Title>{display.legend.record}</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Form className="form" id="form-cadastre" validated={invalidatedForm}>
                                    <LostAndFoundRecord
                                        title={props.title}
                                        isEdit={isEditForm}
                                        identifier={lostAndFoundId === 0}
                                        viewOnly={props.viewOnly}

                                        created={created}
                                        updated={updated}
                                        listEstate={listEstate}

                                        estateId={estateId}
                                        name={name}
                                        description={description}
                                        launch={launch}
                                        delivered={delivered}
                                        setEstateId={setEstateId}
                                        setName={setName}
                                        setDescription={setDescription}
                                        setLaunch={setLaunch}
                                        setDelivered={setDelivered}
                                    />
                                </Form>
                            </Card.Body>
                            <Card.Footer className="text-right">
                                <Button className="me-2" onClick={ (e) => onClick_CancelLostAndFound(e) } variant="contained" color="secondary">{display.buttom.cancel}</Button>
                                {!props.viewOnly && <Button onClick={ (e) => onClick_SaveLostAndFound(e) } disabled={sending} variant="contained" color="primary">
                                    { sending ? <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <FaSave className="me-2" size={22} /> } {' '}
                                    {display.buttom.save}
                                </Button>}
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    } // viewCadastreForm

    return (
        <>
            { viewCadastreForm() }
        </>
    );

}

export default LostAndFoundCondominiumForm;
